import { computed, Injectable, Signal, signal, WritableSignal } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class CartPreviewService {

    #isDeletingProduct: WritableSignal<boolean> = signal(false);
    isDeletingProduct: Signal<boolean> = computed(() => this.#isDeletingProduct());

    setIsDeletingProduct(value: boolean) {
        this.#isDeletingProduct.update(() => value);
    }

}